import React, { useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Controller } from "react-hook-form";
import { Disclaimer } from "./Disclaimer";

const parentescoOptions = [
    { label: "Padre/Madre", value: "Padre/Madre" },
    { label: "Hijo/Hija", value: "Hijo/Hija" },
    { label: "Hermano/Hermana", value: "Hermano/Hermana" },
    { label: "Tío/Tía", value: "Tío/Tía" },
    { label: "Sobrino/Sobrina", value: "Sobrino/Sobrina" },
    { label: "Primo/Prima", value: "Primo/Prima" },
    { label: "Abuelo/Abuela", value: "Abuelo/Abuela" },
    { label: "Nieto/Nieta", value: "Nieto/Nieta" },
    { label: "Suegro/Suegra", value: "Suegro/Suegra" },
    { label: "Yerno/Nuera", value: "Yerno/Nuera" },
    { label: "Cuñado/Cuñada", value: "Cuñado/Cuñada" },
    { label: "Amigo/Amiga", value: "Amigo/Amiga" },
    { label: "Colega de trabajo", value: "Colega de trabajo" },
    { label: "Vecino/Vecina", value: "Vecino/Vecina" },
    { label: "Jefe", value: "Jefe" },
    { label: "Supervisor", value: "Supervisor" },
    { label: "Compañero de estudios", value: "Compañero de estudios" },
    { label: "Profesor", value: "Profesor" },
    { label: "Mentor", value: "Mentor" },
    { label: "Arrendador", value: "Arrendador" },
    { label: "Inquilino", value: "Inquilino" },
    { label: "Compañero de piso", value: "Compañero de piso" },
    { label: "Cliente", value: "Cliente" },
    { label: "Proveedor", value: "Proveedor" },
    { label: "Socio", value: "Socio" },
    { label: "Tutor", value: "Tutor" },
    { label: "Entrenador", value: "Entrenador" },
    { label: "Coach", value: "Coach" },
    { label: "Abogado", value: "Abogado" },
    { label: "Contador", value: "Contador" },
    { label: "Vecino cercano", value: "Vecino cercano" },
    { label: "Conocido", value: "Conocido" },
    { label: "Otro", value: "Otro" },
];

const ReferenceBlock = ({ num, register, errors, control }) => {
    const dropRef = useRef(null);
    return (
        <div className="px-0 py-3 col-12">
            <div className="col-12 flex p-0">
                <div className="col-4">
                    <InputText
                        maxLength={50}
                        {...register(`rf${num}_nombre`, { required: true })}
                        autoComplete="given-name"
                        placeholder={`Nombre * (Ref. ${num})`}
                        className={"EmailInput w-full TextInput " + (errors[`rf${num}_nombre`] ? "p-invalid" : "")}
                    />
                </div>
                <div className="col-4">
                    <InputText
                        maxLength={50}
                        {...register(`rf${num}_apellidoP`)}
                        autoComplete="family-name"
                        placeholder="Apellido Paterno"
                        className={"EmailInput w-full TextInput " + (errors[`rf${num}_apellidoP`] ? "p-invalid" : "")}
                    />
                </div>
                <div className="col-4">
                    <InputText
                        maxLength={50}
                        {...register(`rf${num}_apellidoM`)}
                        autoComplete="additional-name"
                        placeholder="Apellido Materno"
                        className={"EmailInput w-full TextInput " + (errors[`rf${num}_apellidoM`] ? "p-invalid" : "")}
                    />
                </div>
            </div>
            <div className="col-12 flex p-0">
                <div
                    className="col-6"
                    onMouseDown={() => dropRef.current?.show?.()}
                >
                    <Controller
                        name={`parent${num}`}
                        control={control}
                        rules={{ required: true, maxLength: 24 }}
                        render={({ field, fieldState }) => (
                            <Dropdown
                                ref={dropRef}
                                inputRef={field.ref}
                                value={field.value}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                onFocus={() => dropRef.current?.show?.()}
                                onClick={() => dropRef.current?.show?.()}
                                options={parentescoOptions}
                                placeholder="Parentesco"
                                className={"Dropdown " + (fieldState.invalid ? "p-invalid" : "")}
                                filter
                                editable
                                panelStyle={{ zIndex: 9999 }}
                            />
                        )}
                    />
                </div>
                <div className="col-6">
                    <InputText
                        maxLength={10}
                        {...register(`tel${num}`, { required: true, maxLength: 10 })}
                        type="tel"
                        autoComplete="tel"
                        placeholder="Teléfono (10 dígitos)"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                        }}
                        className={"EmailInput w-full TextInput " + (errors[`tel${num}`] ? "p-invalid" : "")}
                    />
                </div>
            </div>
        </div>
    );
};

export const References = ({ register, errors, control }) => (
    <>
        <div className="TopText2 pt-4">
            <span>
                Ingresa 3 referencias. De preferencia, que no sean familiares (se permite máximo 1 familiar).
            </span>
        </div>
        <ReferenceBlock num={1} register={register} errors={errors} control={control} />
        <ReferenceBlock num={2} register={register} errors={errors} control={control} />
        <ReferenceBlock num={3} register={register} errors={errors} control={control} />
        <Disclaimer control={control} errors={errors} />
    </>
);
